export const GEOLOCATION_API = "https://ipapi.co/json/";
